import type { VideoJob } from '../services/local-video';

const messages = [
  'Looking around the internet for a data center..',
  'Rooting around for some spare GPU chips..',
  'Huh..did someone hide all the data centers??',
  'Where oh where did my GPUs go? Oh where oh where have they gone?',
] as const;

const messageIntervalMs = 30_000;

/** Keep the waiting sequence stable across polling and page reloads. */
export function videoQueueWaitMessage(job: VideoJob, cloud: boolean, now: number): string | null {
  const waiting = job.state === 'queued' && ['waiting_capacity', 'starting_gpu'].includes(job.phase)
    || job.state === 'processing' && job.phase === 'starting_gpu';
  if (!cloud || !waiting || job.progress > 0 || (job.frameProgress?.captured ?? 0) > 0) return null;
  const submittedAt = Date.parse(job.createdAt ?? '');
  const age = Number.isFinite(submittedAt) ? Math.max(0, now - submittedAt) : 0;
  return messages[Math.floor(age / messageIntervalMs) % messages.length]!;
}
